export default {
  message: {
    no_data: 'お客様が注文できる商品は、現在ございません。',
  },
};
